import type { GetStreamsParams } from '@vlabs/api/artemy/model';

import type { SourceStreamsFilters } from '../filters/useSourceFilters';

export const DEFAULT_STREAMS_PAGE_SIZE = 25;

// ponytail: enriched: 0 — потоки запрашиваются всегда с личными параметрами,
// без мержа с группами (механика синхронизации GUI-3947)
export function getStreamsParams(
  groupId: string,
  filters: SourceStreamsFilters = {},
): GetStreamsParams {
  return {
    group_id: groupId,
    enriched: 0,
    page: filters.page ?? 1,
    page_size: filters.page_size ?? DEFAULT_STREAMS_PAGE_SIZE,
    ...(filters.names ? { names: filters.names } : {}),
    ...(filters.statuses?.length ? { statuses: filters.statuses } : {}),
    ...(filters.reference ? { reference: filters.reference } : {}),
    ...(filters.order ? { order: filters.order } : {}),
  };
}
